import React from 'react';
import { DividerStyle } from './style';
import { IDivider } from './types';

const Divider: React.FC<IDivider> = (props: IDivider) => {
  const { fullWidth, width } = props;
  return <DividerStyle width={width} fullWidth={fullWidth} />;
};
export default Divider;
